import type { ReactNode } from "react";

export function R1SectionLabel({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <span
      className={[
        "text-[11px] font-semibold uppercase tracking-[0.08em] text-slate-500",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      {children}
    </span>
  );
}

export function R1MetaText({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <span
      className={["text-xs text-slate-500", className]
        .filter(Boolean)
        .join(" ")}
    >
      {children}
    </span>
  );
}
